import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Footer.css'; // Custom styles

const Footer = () => {
  return (
    <footer className="footer mt-5 bg-dark text-white py-4">
      <div className="container">
        <div className="row">
          {/* About Section */}
          <div className="col-md-3">
            <h5>About</h5>
            <ul className="list-unstyled">
              <li><a href="#bureau">The Bureau</a></li>
              <li><a href="#management">Our Management</a></li>
              <li><a href="#mandate">Mandate and Responsibility</a></li>
              <li><a href="#archive">Archive (Publication)</a></li>
            </ul>
            <h6 className="mt-3">Follow us</h6>
            <div className="social-icons">
              <a href="https://www.facebook.com" className="me-2"><i className="fab fa-facebook"></i></a>
              <a href="https://www.twitter.com" className="me-2"><i className="fab fa-twitter"></i></a>
              <a href="https://www.youtube.com" className="me-2"><i className="fab fa-youtube"></i></a>
              <a href="https://www.instagram.com"><i className="fab fa-instagram"></i></a>
            </div>
          </div>

          {/* Contact Us Section */}
          <div className="col-md-3">
            <h5>Contact us</h5>
            <ul className="list-unstyled">
              <li><i className="fas fa-phone-alt"></i> +251 52892414</li>
              <li><i className="fas fa-phone-alt"></i> +251 41656747  </li>
              <li><i className="fas fa-fax"></i> +251 03672983</li>
              <li><i className="fas fa-envelope"></i> afartour@ethionet.et</li>
              <li><i className="fas fa-map-marker-alt"></i> Samara, Ethiopia</li>
            </ul>
          </div>

          {/* Destinations Section */}
          <div className="col-md-3">
            <h5>Destinations</h5>
            <ul className="list-unstyled">
              <li><a href="#Awash park">Awash park</a></li>
              <li><a href="#Danakil Depression">Danakil Depression</a></li>
              <li><a href="#Erta Ale Volcano">Erta Ale Volcano</a></li>
              <li><a href="#Lake Abbe&Lake Afrera">Lake Abbe&Lake Afrera</a></li>
              <li><a href="#Dallol Hydrothermal Field">Dallol Hydrothermal Field</a></li>
            </ul>
          </div>

          {/* Things to do Section */}
          <div className="col-md-3">
            <h5>Things to do</h5>
            <ul className="list-unstyled">
              <li><a href="#Hot Springs">Hot Springs</a></li>
              <li><a href="#Attend Camel Races">Attend Camel Races</a></li>
              <li><a href="#Overnight Volcano Trek">Overnight Volcano Trek</a></li>
              <li><a href="#Visit Traditional Afar Villages">Visit Traditional Afar Villages</a></li>
              <li><a href="#Explore Limestone Chimneys">Explore Limestone Chimneys</a></li>
             
            </ul>
          </div>
        </div>

        <hr className="my-4" />

        <div className="row text-center">
          <div className="col-md-12">
            <p>© 2024 Afar Region Tourism Bureau - Powered by <a href="https://www.ministryoftourism.gov">Ministry of Tourism</a></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;